module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAhCAYAAADefFUGAAAACXBIWXMAABcRAAAXEQHKJvM/AAABBklEQVRoge3buw3CMBSF4RPEAIzABiAlPYzECGzASgzgImwCEwRZSpBokti+DyPOL93GcnW/1m6GYQCbr+u6XbwQQnh6rmpDp/lGqHucCc0rYi23H+fgDUashUIIPYAzgJc3GLFWVAsYsVZWAxixEvIGI1ZinmDEysgLjFiZeYARqyBrMGIVZglGLIGswIgllAUYsQTTBiOWcJpgxFJIC4xYSmmAEUsxaTBiKScJRiyDpMCIZZQEGLEMKwUjlnElYMRyKBeMWE7lgBHLsVQwYjmXAkasCloLRqxKWgPWtG17BOD64J59FT1u48EjAk6/VyJW/CFx4r6q7QO2BdD/+zZ+oAuA6xueYbusSlpvtQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/jiantou1.png
// module id = KO4x
// module chunks = 1